import {
  downloadExportedFiscalCapitalBalance,
  getFiscalCapitalBalanceList,
  getAccountingCapitalBalanceList,
  downloadExportedAccountingCapitalBalance,
  getFiscalCapitalBalanceSummary,
  getAccountingCapitalBalanceSummary,
  getFiscalCapitalBalanceKpis,
  getAccountingCapitalBalanceKpis,
  getFiscalTerminationAudit,
  getAccountingTerminationAudit
} from 'src/services/capitalBalanceService';
import { SnackBarVariants } from 'src/utils/constants/common';
import { asyncActionCreator } from 'src/utils/loadingUtils';
import getOptionsFromState from 'src/utils/balanceUtils';
import {
  selectFiscalCapitalBalanceQueryOptions,
  selectAccountingCapitalBalanceQueryOptions,
  selectFiscalTerminationAuditQueryOptions,
  selectAccountingTerminationAuditQueryOptions
} from '../selectors/capitalBalanceSelectors';
import { showMessage } from './snackBarActions';
// FISCAL
export const LOAD_FISCAL_CAPITAL_BALANCE = asyncActionCreator(
  'LOAD_FISCAL_CAPITAL_BALANCE'
);
export const DOWNLOAD_FISCAL_CAPITAL_BALANCE = asyncActionCreator(
  'DOWNLOAD_FISCAL_CAPITAL_BALANCE'
);
export const CLEAR_FISCAL_CAPITAL_BALANCE = 'CLEAR_FISCAL_CAPITAL_BALANCE';
export const SAVE_FISCAL_CAPITAL_BALANCE_OPTIONS =
  'SAVE_FISCAL_CAPITAL_BALANCE_OPTIONS';
export const CLEAR_FISCAL_CAPITAL_BALANCE_OPTIONS =
  'CLEAR_FISCAL_CAPITAL_BALANCE_OPTIONS';

// ACCOUNTING
export const LOAD_ACCOUNTING_CAPITAL_BALANCE = asyncActionCreator(
  'LOAD_ACCOUNTING_CAPITAL_BALANCE'
);
export const DOWNLOAD_ACCOUNTING_CAPITAL_BALANCE = asyncActionCreator(
  'DOWNLOAD_ACCOUNTING_CAPITAL_BALANCE'
);
export const CLEAR_ACCOUNTING_CAPITAL_BALANCE =
  'CLEAR_ACCOUNTING_CAPITAL_BALANCE';
export const SAVE_ACCOUNTING_CAPITAL_BALANCE_OPTIONS =
  'SAVE_ACCOUNTING_CAPITAL_BALANCE_OPTIONS';
export const CLEAR_ACCOUNTING_CAPITAL_BALANCE_OPTIONS =
  'CLEAR_ACCOUNTING_CAPITAL_BALANCE_OPTIONS';

export const LOAD_FISCAL_CAPITAL_BALANCE_SUMMARY = asyncActionCreator(
  'LOAD_FISCAL_CAPITAL_BALANCE_SUMMARY'
);
export const LOAD_ACCOUNTING_CAPITAL_BALANCE_SUMMARY = asyncActionCreator(
  'LOAD_ACCOUNTING_CAPITAL_BALANCE_SUMMARY'
);

export const LOAD_FISCAL_CAPITAL_BALANCE_KPIS = asyncActionCreator(
  'LOAD_FISCAL_CAPITAL_BALANCE_KPIS'
);
export const LOAD_ACCOUNTING_CAPITAL_BALANCE_KPIS = asyncActionCreator(
  'LOAD_ACCOUNTING_CAPITAL_BALANCE_KPIS'
);

export const LOAD_FISCAL_TERMINATION_AUDIT = asyncActionCreator(
  'LOAD_FISCAL_TERMINATION_AUDIT'
);
export const CLEAR_FISCAL_TERMINATION_AUDIT = 'CLEAR_FISCAL_TERMINATION_AUDIT';
export const SAVE_FISCAL_TERMINATION_AUDIT_OPTIONS =
  'SAVE_FISCAL_TERMINATION_AUDIT_OPTIONS';

export const LOAD_ACCOUNTING_TERMINATION_AUDIT = asyncActionCreator(
  'LOAD_ACCOUNTING_TERMINATION_AUDIT'
);
export const CLEAR_ACCOUNTING_TERMINATION_AUDIT =
  'CLEAR_ACCOUNTING_TERMINATION_AUDIT';
export const SAVE_ACCOUNTING_TERMINATION_AUDIT_OPTIONS =
  'SAVE_ACCOUNTING_TERMINATION_AUDIT_OPTIONS';

// FISCAL ACTIONS
export const clearFiscalCapitalBalanceOptions = () => dispatch => {
  dispatch({ type: CLEAR_FISCAL_CAPITAL_BALANCE_OPTIONS });
};

export const clearFiscalCapitalBalance = () => dispatch => {
  dispatch({ type: CLEAR_FISCAL_CAPITAL_BALANCE });
};

export const loadFiscalCapitalBalance = options => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: LOAD_FISCAL_CAPITAL_BALANCE.start });
    dispatch({
      type: SAVE_FISCAL_CAPITAL_BALANCE_OPTIONS,
      options
    });

    const reqOptions = getOptionsFromState(
      selectFiscalCapitalBalanceQueryOptions,
      getState
    );

    const fiscalCapitalBalance = await getFiscalCapitalBalanceList(reqOptions);

    return dispatch({
      type: LOAD_FISCAL_CAPITAL_BALANCE.success,
      ...fiscalCapitalBalance
    });
  } catch (error) {
    dispatch(showMessage({ message: error.message, variant: 'error' }));
    return dispatch({ type: LOAD_FISCAL_CAPITAL_BALANCE.failure });
  }
};

export const downloadExcelFiscalCapitalBalance = options => async (
  dispatch,
  getState
) => {
  try {
    dispatch({
      type: DOWNLOAD_FISCAL_CAPITAL_BALANCE.start
    });

    dispatch({
      type: SAVE_FISCAL_CAPITAL_BALANCE_OPTIONS,
      options
    });

    const reqOptions = getOptionsFromState(
      selectFiscalCapitalBalanceQueryOptions,
      getState
    );
    await downloadExportedFiscalCapitalBalance(reqOptions);

    return dispatch({
      type: DOWNLOAD_FISCAL_CAPITAL_BALANCE.success
    });
  } catch (error) {
    dispatch(showMessage({ message: error.message, variant: 'error' }));
    return dispatch({ type: DOWNLOAD_FISCAL_CAPITAL_BALANCE.failure });
  }
};

// ACCOUNTING ACTIONS
export const clearAccountingCapitalBalanceOptions = () => dispatch => {
  dispatch({ type: CLEAR_ACCOUNTING_CAPITAL_BALANCE_OPTIONS });
};

export const clearAccountingCapitalBalance = () => dispatch => {
  dispatch({ type: CLEAR_ACCOUNTING_CAPITAL_BALANCE });
};

export const loadAccountingCapitalBalance = options => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: LOAD_ACCOUNTING_CAPITAL_BALANCE.start });

    dispatch({
      type: SAVE_ACCOUNTING_CAPITAL_BALANCE_OPTIONS,
      options
    });
    const reqOptions = getOptionsFromState(
      selectAccountingCapitalBalanceQueryOptions,
      getState
    );

    const accountingCapitalBalance = await getAccountingCapitalBalanceList(
      reqOptions
    );

    return dispatch({
      type: LOAD_ACCOUNTING_CAPITAL_BALANCE.success,
      ...accountingCapitalBalance
    });
  } catch (error) {
    dispatch(showMessage({ message: error.message, variant: 'error' }));
    return dispatch({
      type: LOAD_ACCOUNTING_CAPITAL_BALANCE.failure,
      error: error.message
    });
  }
};

export const downloadExcelAccountingCapitalBalance = options => async (
  dispatch,
  getState
) => {
  try {
    dispatch({
      type: DOWNLOAD_ACCOUNTING_CAPITAL_BALANCE.start
    });

    dispatch({
      type: SAVE_ACCOUNTING_CAPITAL_BALANCE_OPTIONS,
      options
    });

    const reqOptions = getOptionsFromState(
      selectAccountingCapitalBalanceQueryOptions,
      getState
    );
    await downloadExportedAccountingCapitalBalance(reqOptions);

    return dispatch({
      type: DOWNLOAD_ACCOUNTING_CAPITAL_BALANCE.success
    });
  } catch (error) {
    dispatch(showMessage({ message: error.message, variant: 'error' }));
    return dispatch({ type: DOWNLOAD_ACCOUNTING_CAPITAL_BALANCE.failure });
  }
};

// SUMMARY ACTIONS
export const loadFiscalCapitalBalanceSummary = options => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: LOAD_FISCAL_CAPITAL_BALANCE_SUMMARY.start });

    dispatch({
      type: SAVE_FISCAL_CAPITAL_BALANCE_OPTIONS,
      options
    });
    const reqOptions = getOptionsFromState(
      selectFiscalCapitalBalanceQueryOptions,
      getState
    );

    const summary = await getFiscalCapitalBalanceSummary(reqOptions);

    return dispatch({
      type: LOAD_FISCAL_CAPITAL_BALANCE_SUMMARY.success,
      ...summary
    });
  } catch (error) {
    dispatch(showMessage({ message: error.message, variant: SnackBarVariants.ERROR }));
    return dispatch({ type: LOAD_FISCAL_CAPITAL_BALANCE_SUMMARY.failure });
  }
};

export const loadAccountingCapitalBalanceSummary = options => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: LOAD_ACCOUNTING_CAPITAL_BALANCE_SUMMARY.start });

    dispatch({
      type: SAVE_ACCOUNTING_CAPITAL_BALANCE_OPTIONS,
      options
    });
    const reqOptions = getOptionsFromState(
      selectAccountingCapitalBalanceQueryOptions,
      getState
    );

    const summary = await getAccountingCapitalBalanceSummary(reqOptions);

    return dispatch({
      type: LOAD_ACCOUNTING_CAPITAL_BALANCE_SUMMARY.success,
      ...summary
    });
  } catch (error) {
    dispatch(showMessage({ message: error.message, variant: SnackBarVariants.ERROR }));
    return dispatch({
      type: LOAD_ACCOUNTING_CAPITAL_BALANCE_SUMMARY.failure
    });
  }
};

// KPI ACTIONS
export const loadFiscalCapitalBalanceKpis = () => async dispatch => {
  try {
    dispatch({ type: LOAD_FISCAL_CAPITAL_BALANCE_KPIS.start });

    const kpis = await getFiscalCapitalBalanceKpis();

    return dispatch({
      type: LOAD_FISCAL_CAPITAL_BALANCE_KPIS.success,
      ...kpis
    });
  } catch (error) {
    dispatch(
      showMessage({ message: error.message, variant: SnackBarVariants.ERROR })
    );
    return dispatch({ type: LOAD_FISCAL_CAPITAL_BALANCE_KPIS.failure });
  }
};

export const loadAccountingCapitalBalanceKpis = () => async dispatch => {
  try {
    dispatch({ type: LOAD_ACCOUNTING_CAPITAL_BALANCE_KPIS.start });

    const kpis = await getAccountingCapitalBalanceKpis();

    return dispatch({
      type: LOAD_ACCOUNTING_CAPITAL_BALANCE_KPIS.success,
      ...kpis
    });
  } catch (error) {
    dispatch(
      showMessage({ message: error.message, variant: SnackBarVariants.ERROR })
    );
    return dispatch({ type: LOAD_ACCOUNTING_CAPITAL_BALANCE_KPIS.failure });
  }
};

// TERMINATION AUDIT ACTIONS
export const loadFiscalTerminationAudit = options => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: LOAD_FISCAL_TERMINATION_AUDIT.start });
    dispatch({
      type: SAVE_FISCAL_TERMINATION_AUDIT_OPTIONS,
      options
    });

    const reqOptions = selectFiscalTerminationAuditQueryOptions(getState());

    const audit = await getFiscalTerminationAudit(reqOptions);

    return dispatch({
      type: LOAD_FISCAL_TERMINATION_AUDIT.success,
      ...audit
    });
  } catch (error) {
    dispatch(
      showMessage({ message: error.message, variant: SnackBarVariants.ERROR })
    );
    return dispatch({ type: LOAD_FISCAL_TERMINATION_AUDIT.failure });
  }
};

export const clearFiscalTerminationAudit = () => dispatch => {
  dispatch({ type: CLEAR_FISCAL_TERMINATION_AUDIT });
};

export const loadAccountingTerminationAudit = options => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: LOAD_ACCOUNTING_TERMINATION_AUDIT.start });
    dispatch({
      type: SAVE_ACCOUNTING_TERMINATION_AUDIT_OPTIONS,
      options
    });

    const reqOptions = selectAccountingTerminationAuditQueryOptions(
      getState()
    );

    const audit = await getAccountingTerminationAudit(reqOptions);

    return dispatch({
      type: LOAD_ACCOUNTING_TERMINATION_AUDIT.success,
      ...audit
    });
  } catch (error) {
    dispatch(
      showMessage({ message: error.message, variant: SnackBarVariants.ERROR })
    );
    return dispatch({ type: LOAD_ACCOUNTING_TERMINATION_AUDIT.failure });
  }
};

export const clearAccountingTerminationAudit = () => dispatch => {
  dispatch({ type: CLEAR_ACCOUNTING_TERMINATION_AUDIT });
};
